import { ProductoAcuerdo } from './producto-acuerdo.model';
import { TipoMoneda } from '../cliente/operaciones/tipoMoneda.model';

export class TarifarioPorCantidad {

  precio: number;
  cantidad: number;

  constructor() {
  }



}



// WEBPACK FOOTER //
// ./src/app/acuerdo/tarifario-por-cantidad.model.ts